import type { KycCheckResponse } from "@fintechprimitives/fpapi";
import appConfig from "../../../../config/appConfig";
import { getFilterLabelsFromFilterPillValues } from "../../../../utils/utils";
import { kycStatusCheckStatusOptions } from "./Filters/constants";
import type { KycStatusCheckListingFilters } from "./Filters/types";
import type { TagStatus } from "./types";

/**
 * KYC status checks are available to verifications-enabled tenants and, additionally, to AMC
 * tenants (their KYC forms link to solicit fetches, which are KYC checks created in the AMC tenant).
 */
export const isKycStatusChecksAccessible = (
  activeTenant?: string | null,
  isAmcTenant?: boolean
) => {
  return Boolean(
    isAmcTenant || appConfig.app.verifications_enabled_tenants.includes(activeTenant ?? "")
  );
};

export const getKycStatusCheckStatusColour = (
  status: KycCheckResponse["status"] | null | undefined
): TagStatus => {
  if (status == null) {
    return "default";
  }

  return status ? "success" : "error";
};

export const getFormattedFilterPillValue = (
  filterName: keyof KycStatusCheckListingFilters,
  filterValue: string | null | undefined
) => {
  switch (filterName) {
    case "status": {
      return getFilterLabelsFromFilterPillValues(filterValue, kycStatusCheckStatusOptions);
    }

    default: {
      return filterValue;
    }
  }
};
